export default function getStoreById(id, stores) {
  return id ? stores.find(store => store.id === id) : null
}
